<div class="service-management">
  <div class="header-label">
    <h2>Service Management</h2>
  </div>

  <div class="top-controls-row">
    <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
      <mat-label>Search</mat-label>
      <input
        matInput
        [value]="searchTerm"
        (input)="onSearch(($any($event.target)).value)"
        placeholder="Type to search..."
        autocomplete="off" />
      <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <button class="add-service-btn top-controls-action-btn" mat-flat-button color="primary" (click)="addService()"
      [disabled]="!clientId || loading">
      Add Service
    </button>
  </div>

  <div *ngIf="errorMessage" class="api-error-banner">
    {{ errorMessage }}
  </div>

  <div class="table-loader" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div class="table-wrapper" [class.loading]="loading">

    <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir" class="full-width">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="no-header"></th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          <button mat-icon-button (click)="remove(row)" [disabled]="isDeletingRow(row)" matTooltip="Delete" class="table-action-btn table-action-delete"
            [attr.aria-label]="'Delete ' + row.ServiceName">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="serviceName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="serviceName">Service Name</th>
        <td mat-cell *matCellDef="let row">
          {{ row.ServiceName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="serviceDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="serviceDescription">Service Description</th>
        <td mat-cell *matCellDef="let row">
          {{ row.ServiceDescription }}
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="startDate">Start Date</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.StartDate as dt">
            {{ dt | date: 'mediumDate' }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div *ngIf="dataSource.data.length === 0" class="no-results-message">
      No services found
    </div>
  </div>

  <mat-paginator [length]="totalCount" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]"
    (page)="onPageChange($event)" showFirstLastButtons>
  </mat-paginator>
</div>